import React, { useState, useEffect } from "react"
import { Row, Col, Image } from 'antd'
import classes from './styles.module.css'
import { Link } from 'react-router-dom'
import i18next from "i18next"
import { useTranslation } from "react-i18next"
import parse from 'html-react-parser';
import micon from '../../img/m_icon.png';

const Collection: React.FC = () => {
    const controller = new AbortController();
    const { signal } = controller;
    const { t } = useTranslation()

    var currentLanguageCode = "el";

    const [categories, setCategories] = useState([]);
    const [pois, setPois] = useState([]);
    const activecategory = 2;
    const [showMore, setShowMore] = useState<boolean>(false)
    
    const getCategory = async () => {
        const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/maincategories?lang=${currentLanguageCode}`
        const response = await fetch(url,
            {
                signal,
                headers: {
                    'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
        if (!response.ok) {
            throw new Error('Data could not be fetched!')
        }
        else {
            return response.json()
        }

    };

    const getCategoryPois = async () => {
        const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/pois?category_id=${activecategory}&lang=${currentLanguageCode}`
        const response = await fetch(url,
            {
                signal,
                headers: {
                    'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
        if (!response.ok) {
            throw new Error('Data could not be fetched!')
        }
        else {

            return response.json()
        }
    };

    useEffect(() => {
        getCategory()
            .then((res) => {
                setCategories(res.success)
                // console.log(res.success)
            })

        getCategoryPois()
            .then((res1) => {
                setPois(res1.success)
                // console.log(res1.success)
            })
            .catch((e) => {
                console.log(e.message)
            })
    }, [i18next.language])

    console.log(categories)

    return (
        <Row>
            {categories.length && 
                <div className={classes.gallerycat}>
                    <div className={classes.gallery}>
                        <div className={classes.headerTitleContainer}> 
                            <div className={classes.headerTitle}>
                                <span>
                                    <img src={micon} alt="banner-icon" className={classes.micon}/>
                                    <h2>{t('Εκθέματα')}</h2>
                                </span>
                                <h2 className={classes.headerText}>{categories[1]['name']}</h2>
                            </div>
                            <img className={classes.headerImage} src={categories[1]['main_image']} alt='museum-banner-img'/>       
                        </div>

                        <div className={classes.exhibitSection}>
                            <h2 className={classes.title}>{t("Εκθέματα")}</h2>
                            {pois.map((poi: any) => {
                                return (
                                <span className={classes.pimg}>
                                    <Image 
                                        src={poi.main_image}
                                        preview={{
                                            destroyOnClose: true,
                                            imageRender: () => (
                                                <div className={classes.exhibitContainer}>
                                                    <img src={poi.main_image} />
                                                    <div className={classes.exhibitInfoContainer}>
                                                    <span>
                                                        <h2>{poi.name}</h2>
                                                        {/* <button>X</button> */}
                                                    </span>
                                                    <p dangerouslySetInnerHTML={{__html: poi.portal_main_info}}></p>
                                                    </div>
                                                </div>
                                            ),
                                            toolbarRender: () => null,
                                        }}
                                    />
                                </span>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
        </Row>
    )
}

export default Collection


// in case we need something from the old design
                        {/* <Row>
                            <div className={classes.top_cat}>
                                <div className="app11">
                                    <div className={classes.desc}>
                                        {Object.values(parse(categories[1]['description']))['0']?.props ? parse(categories[1]['description']).toString.length != 0 ? "" : (showMore ? parse(categories[1]['description']) : parse(`${categories[1]['description']}`.substring(0, 868) + `...`)) : ""}

                                        {Object.values(parse(categories[1]['description']))['0']?.props && parse(categories[1]['description']).toString.length == 0 ? <button style={{ fontSize: 15, color: 'red', border: 'none', background: 'none', margin: '-1rem 4vw', cursor: 'pointer' }} className={classes.more} onClick={() => { setShowMore(!showMore) }}>{!showMore ? t('Δείτε περισσότερα') : t('Δείτε λιγότερα')}</button> : ""}
                                    </div>

                                </div>
                            </div>
                        </Row>
                            
                        <Row>
                            <div className={classes.top_cat}>
                                <div className={classes.gridContainer}>
                                    {pois.map(poi =>
                                        <Link to={`/collection/${poi['id']}`} state={{ category: poi['name'] }}>
                                            <div className={classes.categoriesimg}>
                                                <img src={poi['main_image']} />
                                                <div className={classes.carouseldesc}>
                                                    <p>{poi['name']}</p>
                                                    <div className={classes.carouselmore}>
                                                        <Link to={`/collection/${poi['id']}`} state={{ category: poi['name'] }}>
                                                            {t('Μάθε περισσότερα')}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                                <br />
                            </div>
                        </Row>   */}